import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playerSelection, setConstraintsData } from '../../../store/slice/createTeamSlice';
import Button from '../button';
import Typo from '../typo';
import FormationPlayerCard from '../formationPlayerCard';
import TotalPoints from '../totalPoints';
import { useConstraintsQuery, useFixturesQuery, usePlayerListsQuery } from 'api/feeds';
import {
  handlePlayerInfoOverlay,
  setClassName,
  setPlayerCard,
  setPlayerInfoOverlay,
  setShowPlayerSectionCTA
} from 'store/slice/overlaySlice';
import Loader from '../loader';
import PlCardInfo from '../plCardInfo';
import { IMG_BASE_PATH, OPEN_MATCH_STATUS } from 'utils/constants';
import { useGetUserCreatedTeamQuery } from 'api';
import { getCookie } from 'utils/commonFunctions';
import config from 'utils/config';

const SelectionCard = ({ openEvent, userTeamData, teamData, matchgameid }) => {
  const [storedEvent, setStoredEvent] = useState(null);
  const fixturedata = useSelector((state) => state.createTeam.gameFixtures);
  // const { data: fixturedata, error: fixtureError, isLoading: fixtureLoading } = useFixturesQuery();
  const gameCookie = getCookie(config.gameCookieName);

  const matchesData = fixturedata;

  const filteredEvents = matchesData?.filter(
    (event) => event.event_status_id === OPEN_MATCH_STATUS
  );

  const matchDetails = filteredEvents?.length > 0 ? filteredEvents[0] : null;
  const isFinalLock = openEvent?.is_final_locked;
  const {
    data: constraintsData,
    error: ConstraintsError,
    isLoading: ConstraintsLoading
  } = useConstraintsQuery();

  const dispatch = useDispatch();

  const ConstraintsData = constraintsData?.Data?.Value;

  useEffect(() => {
    if (!openEvent) {
      const savedEvent = localStorage.getItem('openEvent');
      if (savedEvent) {
        setStoredEvent(JSON.parse(savedEvent));
      }
    }
  }, [openEvent]);

  const activeEvent = openEvent || storedEvent;
  const {
    data: playerlistdata,
    error: PlayerError,
    isLoading: PlayerLoading
  } = usePlayerListsQuery(
    { gamedayId: openEvent?.gameday_id || activeEvent?.gameday_id },
    { skip: !openEvent?.gameday_id || !activeEvent?.gameday_id, refetchOnMountOrArgChange: true }
  );

  const selectedPlayers = useSelector((state) => state?.createTeam?.selectedPlayers || []);
  // const showPlayerListOverlay = useSelector((state) => state?.overlay.showPlayerListOverlay);

  const togglePlayerListOverlay = (state) => {
    dispatch(handlePlayerInfoOverlay(state));
  };

  const handleRemovePlayer = (role) => {
    const updatedPlayers = selectedPlayers.filter((p) => p.skill_name !== role);
    dispatch(playerSelection({ ply: updatedPlayers }));
  };

  if (ConstraintsLoading || PlayerLoading || ConstraintsError || PlayerError) {
    return <Loader />;
  }

  const skillsArray = ConstraintsData?.composition_skills || [];
  const skillroles = skillsArray.map((constraint) => constraint.skill_name);

  const roleBackground = skillsArray.reduce((acc, constraint) => {
    acc[constraint.skill_name] = `var(--${constraint.skill_short_name.toLowerCase()}-bg)`;
    return acc;
  }, {});

  return (
    <>
      {skillroles.map((role, index) => {
        const player = selectedPlayers.find((p) => p.skill_name === role);
        const background = player ? roleBackground[role] : null;

        return (
          <div
            key={index}
            className={`si-selectionCard ${player ? 'si-select' : ''}`}
            style={{ background }}
          >
            <div className='si-selectionCard__cta'>
              {!player && (
                <Button
                  variant='onlyIcon'
                  icon='lms-add'
                  classes='si-btn__add'
                  onClick={() => togglePlayerListOverlay(role)}
                />
              )}
              {(!gameCookie?.guid && openEvent?.event_status_id == 2 && player) ||
              (openEvent?.event_status_id == 1 && player) ? (
                <Button
                  variant='onlyIcon'
                  icon='lms-close'
                  classes='si-btn__close'
                  onClick={() => handleRemovePlayer(role)}
                />
              ) : (gameCookie?.guid && openEvent?.event_status_id == 2 && !matchgameid && player) ||
                (openEvent?.event_status_id == 1 && player) ? (
                <Button
                  variant='onlyIcon'
                  icon='lms-close'
                  classes='si-btn__close'
                  onClick={() => handleRemovePlayer(role)}
                />
              ) : null}
            </div>

            {player ? (
              <div
                className='si-selectionCard__player-wrap'
                onClick={() => {
                  openEvent?.event_status_id != 2 && dispatch(setClassName(true));
                  if (
                    openEvent?.event_status_id != 1 ||
                    (openEvent?.event_status_id == 2 && !matchgameid)
                  ) {
                    dispatch(setShowPlayerSectionCTA(false));
                  }

                  dispatch(setPlayerCard(player));
                  dispatch(setPlayerInfoOverlay(true));
                }}
              >
                <FormationPlayerCard
                  thumbnail={player?.id}
                  plyrName={player.short_name || 'No Player'}
                  fallback={`${IMG_BASE_PATH}images/players/2.png`}
                />
              </div>
            ) : (
              <div className='si-selectionCard__head'>
                <Typo
                  transKey={`player_skill_${role.toLowerCase()}`}
                  component='h4'
                  className='si-selectionCard__heading'
                >
                  {role}
                </Typo>
              </div>
            )}
            {(player && activeEvent?.event_status_id == 1) ||
            (player && !matchgameid && activeEvent?.event_status_id != 4) ? (
              <div className='si-selectionCard__player-infoBottom'>
                <PlCardInfo data={player} />
              </div>
            ) : matchgameid && activeEvent?.event_status_id != 1 ? (
              <div className='si-selectionCard__points-wrap'>
                <TotalPoints totalPoints={player?.gd_pts} />
              </div>
            ) : null}
            {/* {false && (
              <div className='si-selectionCard__points-wrap'>
                <TotalPoints totalPoints={9999} />
              </div>
            )} */}
          </div>
        );
      })}
    </>
  );
};

export default SelectionCard;
